module.exports = __webpack_public_path__ + "media/images/pc/maedori_photowedding/plan_chapel@2x-c3c64da3f4f9f014491e2c5b5cfa8b5e.webp";